<header class="header">
  <div class="header__top-row">
    <button mat-icon-button class="header__menu-button" (click)="navService.toggleMobileMenu()">
      <mat-icon>menu</mat-icon>
    </button>

    <h1 class="header__title">
      {{ navService.current?.name }}
    </h1>
  </div>

  <div class="header__logo"></div>

  <div class="settings__profile">
    <div class="client__profile">
      <mat-select (selectionChange)="setClienteDefault($event.value)" [(value)]="clienteDefault">
        <mat-select-trigger class="client__profile__selected">
          <mat-icon>assignment_ind</mat-icon>
          <span class="client__profile__selected__username">{{ getClienteById(clienteDefault) | async }}</span>
        </mat-select-trigger>
        <mat-option class="client__options" *ngFor="let cliente of clientesUsuario | async" [value]="cliente.id">
          {{ cliente.razaoSocial }}
        </mat-option>
      </mat-select>
    </div>
    <div>
      <button class="header__profile" [matMenuTriggerFor]="menu">
        <mat-icon>person_outline</mat-icon>
        <span class="header__profile__username">{{ authService.credentials?.usuario?.nomeFantasia }}</span>
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
    </div>
  </div>
  
  <mat-menu #menu="matMenu">
    <button mat-menu-item routerLink="/minha-conta" routerLinkActive="active">
      <mat-icon>manage_accounts</mat-icon>
      <span>Minha conta</span>
    </button>

    <mat-divider></mat-divider>

    <button mat-menu-item>
      <mat-icon>info</mat-icon>
      <span>Sobre</span>
    </button>

    <mat-divider></mat-divider>

    <button mat-menu-item routerLink="/logout" routerLinkActive="active">
      <mat-icon>exit_to_app</mat-icon>
      <span>Fazer logout</span>
    </button>
  </mat-menu>
</header>